import React from "react";

export const ExplanationEn = () => {

  return (
    <>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Ponzi Scheme Explained</h2>
      <p className="text-gray-700 mb-4">
        A <strong>Ponzi scheme</strong> is a type of financial fraud that promises high returns to investors but actually pays returns using funds from new investors rather than legitimate profits. Here's how it works step by step:
      </p>

      <h3><strong>Step 1: The Scheme is Created</strong></h3>
      <ul>
        <li>A person or company promotes an investment opportunity, promising <strong>high returns with little or no risk</strong>.</li>
        <li>They may claim to use <strong>special trading strategies, real estate, or cryptocurrency</strong> to generate profits.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 2: Early Investors are Paid</strong></h3>
      <ul>
        <li>Initial investors provide money.</li>
        <li>Instead of making legitimate investments, the organizer <strong>pays "returns" to earlier investors</strong> using the money from new investors.</li>
        <li>This creates <strong>trust and excitement</strong>, encouraging early investors to <strong>reinvest</strong> and recruit others.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 3: More Investors Join</strong></h3>
      <ul>
        <li>Word spreads, and more people <strong>invest</strong>, believing it’s a profitable opportunity.</li>
        <li>The scheme grows as new money flows in, allowing the organizer to keep paying old investors and maintaining the illusion of success.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 4: The Scheme Becomes Unsustainable</strong></h3>
      <ul>
        <li>As more people join, <strong>larger payouts are required</strong>.</li>
        <li>At some point, <strong>new investments slow down</strong>, but existing investors still expect their returns.</li>
        <li>Since there’s <strong>no real profit</strong>, the organizer struggles to pay returns.</li>
      </ul>

      <h3 className="mt-2"><strong>Step 5: The Collapse</strong></h3>
      <ul>
        <li>When the organizer <strong>can’t attract enough new investors</strong>, they <strong>fail to pay promised returns</strong>.</li>
        <li>Investors <strong>panic and try to withdraw</strong> their money, but the organizer <strong>can’t pay</strong>.</li>
        <li>The scheme <strong>collapses</strong>, and the organizer either <strong>disappears with the remaining funds</strong> or gets caught.</li>
      </ul>

      <h3 className="mt-2"><strong>Key Signs of a Ponzi Scheme</strong></h3>
      <ul>
        <li>1. Guaranteed high returns with no risk</li>
        <li>2. Consistent returns despite market conditions</li>
        <li>3. Complex or secretive investment strategies</li>
        <li>4. Difficulty withdrawing funds</li>
        <li>5. Reliance on new investors to pay existing ones</li>
      </ul>
    </>
  );
};
